import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import type { ApiError, ProblemDetailsSchema } from '@/js/libs/api';
import { Button, GapWrapper, Notification, Section } from '@/js/libs/ui/src/V2';

import { getErrorMessage } from 'src/hooks/useRequestErrorNotification.ts';
import { PageWrapper } from './styles.ts';

type Props = {
  error: ApiError<typeof ProblemDetailsSchema>;
  exitLabel: string;
  onExit: () => void;
  onReload: () => void;
};

// Reports a failed identity load in place of the app and offers to load the identity again or to leave through the given
// exit.
export const IdentityErrorPage = memo(function IdentityErrorPage({ error, exitLabel, onExit, onReload }: Props) {
  const [t] = useTranslation(['backend', 'common']);

  return (
    <PageWrapper>
      <GapWrapper lg $align='center' $direction='column'>
        <Section>
          <Section.Item>
            <GapWrapper xl $direction='column' $align='center'>
              <Notification uncloseable fullWidth type='error' title={t('common:ERROR')} body={getErrorMessage(error.response, t)} />
              <GapWrapper sm $align='center'>
                <Button primary onClick={onReload}>
                  {t('common:RELOAD')}
                </Button>
                <Button secondary onClick={onExit}>
                  {exitLabel}
                </Button>
              </GapWrapper>
            </GapWrapper>
          </Section.Item>
        </Section>
      </GapWrapper>
    </PageWrapper>
  );
});
